const RegoLookupActions = {
    SHOW_ACTION: 'SHOW_ACTION',
    SHOW_ACTION_V2: 'SHOW_ACTION_V2',
    HIDE_ACTION: 'HIDE_ACTION',

    SHOW_INPUT_LAYER: 'SHOW_INPUT_LAYER',
    HIDE_INPUT_LAYER: 'HIDE_INPUT_LAYER',

    SHOW_CONFIRMATION_LAYER: 'SHOW_CONFIRMATION_LAYER',
    HIDE_CONFIRMATION_LAYER: 'HIDE_CONFIRMATION_LAYER',
    
    SHOW_VEHICLE_NOT_PROVIDED_LAYER: 'SHOW_VEHICLE_NOT_PROVIDED_LAYER',
    HIDE_VEHICLE_NOT_PROVIDED_LAYER: 'HIDE_VEHICLE_NOT_PROVIDED_LAYER',

    SET_VEHICLE_NOT_PROVIDED_COMMENT: 'SET_VEHICLE_NOT_PROVIDED_COMMENT',
    
    SET_STATE: 'SET_STATE',
    SET_POSTCODE: 'SET_POSTCODE',

    SHOW_REGISTRATION_INVALID: 'SHOW_REGISTRATION_INVALID',
    HIDE_REGISTRATION_INVALID: 'HIDE_REGISTRATION_INVALID',

    SHOW_POSTCODE_INVALID: 'SHOW_POSTCODE_INVALID',
    HIDE_POSTCODE_INVALID: 'HIDE_POSTCODE_INVALID',
    SET_REGISTRATION: 'SET_REGISTRATION',

    SHOW_LICENCE_NOT_FOUND: 'SHOW_LICENCE_NOT_FOUND',
    HIDE_LICENCE_NOT_FOUND: 'HIDE_LICENCE_NOT_FOUND',

    DISABLE_BUTTON_CONTINUE: 'DISABLE_BUTTON_CONTINUE',
    ENABLE_BUTTON_CONTINUE: 'ENABLE_BUTTON_CONTINUE',

    DISABLE_BUTTON_CONFIRM: 'DISABLE_BUTTON_CONFIRM',
    ENABLE_BUTTON_CONFIRM: 'ENABLE_BUTTON_CONFIRM',

    SET_TYRE: 'SET_TYRE',
    SET_TYRE_OPTIONS: 'SET_TYRE_OPTIONS',
    SHOW_TYRES: 'SHOW_TYRES',
    HIDE_TYRES: 'HIDE_TYRES',

    SHOW_CONFIRM_BUTTON: 'SHOW_CONFIRM_BUTTON',
    HIDE_CONFIRM_BUTTON: 'HIDE_CONFIRM_BUTTON',

    SHOW_INFO_LAYER: 'SHOW_INFO_LAYER',
    HIDE_INFO_LAYER: 'HIDE_INFO_LAYER',

    SET_VALUES: 'SET_VALUES',
    RESET_VALUES: 'RESET_VALUES',
    SET_VEHICLE_DATA: 'SET_VEHICLE_DATA',

    SET_POSTCODE_SUGGESTION: 'SET_POSTCODE_SUGGESTION'
};

export { RegoLookupActions };
